import { createContext, useContext, useEffect, useState } from 'react'
import { useAuth } from './AuthContext'
import { puedeGestionarUsuarios } from '../services/usuariosService'

const AdminPermissionsContext = createContext(null)

// Permisos administrativos explícitos del usuario (validados por el backend).
// Solo deciden qué se muestra: cada operación vuelve a verificarse en la Edge Function.
export function AdminPermissionsProvider({ children }) {
  const { authUser } = useAuth()
  const userId = authUser?.id
  const [state, setState] = useState({ userId: null, gestionarUsuarios: false })

  useEffect(() => {
    if (!userId) return undefined
    let active = true
    puedeGestionarUsuarios()
      .then((allowed) => { if (active) setState({ userId, gestionarUsuarios: allowed }) })
      // Ante cualquier error se niega el acceso (falla cerrado).
      .catch(() => { if (active) setState({ userId, gestionarUsuarios: false }) })
    return () => { active = false }
  }, [userId])

  const value = {
    // Carga solo una vez por usuario; no se reinicia en refrescos de token.
    loading: Boolean(userId) && state.userId !== userId,
    puedeGestionarUsuarios: state.userId === userId && state.gestionarUsuarios,
  }
  return <AdminPermissionsContext.Provider value={value}>{children}</AdminPermissionsContext.Provider>
}

export function useAdminPermissions() {
  const context = useContext(AdminPermissionsContext)
  if (!context) throw new Error('useAdminPermissions debe utilizarse dentro de AdminPermissionsProvider')
  return context
}
